import type {
  IBaseFormInput,
  IFormPlainDataListboxItem,
  IFormPlainDataListboxPropsChangeState,
  InputMessageIcon,
  InputMessageSeverity,
  SelectInputType,
  VFormInputBaseProps,
} from '@modules/forms/types';
import type { IItemLocalizationOptions } from '@modules/i18n/types';

export enum ListboxSortType {
  DEFAULT = 'default',
  CHECKED = 'checked',
}

export interface IFormPlainDataListboxProps<T extends SelectInputType>
  extends IBaseFormInput<T>, VFormInputBaseProps, IItemLocalizationOptions {
  data?: IFormPlainDataListboxItem<T>[];
  disableCheckboxFilter?: boolean;
  filterQuery?: string;
  resetCounter?: number;
  noBorder?: boolean;
  uploadFileBtn?: boolean;
  sortButton?: boolean;
  isLoading?: boolean;
  sortAfterChangeItem?: boolean;
  showInfoMessage?: boolean;
  infoMessage?: string;
  messageSeverity?: InputMessageSeverity;
  messageIcon?: InputMessageIcon;
}

export interface IFormPlainDataListboxEmits<T extends SelectInputType> {
  (e: 'change', data: IFormPlainDataListboxPropsChangeState<T>): void;
  (e: 'upload-file'): void;
}

export interface IFormPlainDataListboxSlots {
  footer?(props: Record<string, never>): void;
}
